<template>
    <transition
        appear
        name="custom-classes-transition"
        enter-active-class="animated fadeIn faster"
        leave-active-class="animated fadeOut faster"
    >
        <popup v-if="show" :is-pass="true">
            <div class="ui-message-tips" v-html="content"></div>
        </popup>
    </transition>
</template>
<script>
import Popup from "./popup";
export default {
    name: "ui-tips",
    components: {
        Popup
    },
    data() {
        return {
            show: false,
            duration: 1000,
            content: ""
        };
    },
    mounted() {
        setTimeout(() => {
            this.show = false;
            this.$nextTick(function() {
                document.body.removeChild(this.$el);
                this.$destroy(true);
            });
        }, this.duration);
    }
};
</script>
<style lang="less" scoped>
.ui-message-tips {
    position: absolute;
    left: 50%;
    top: 40%;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 20px 50px;
    transform: translate(-40%, -50%);
    border-radius: 10px;
    box-shadow: 0 0px 35px rgba(0, 0, 0, 0.3);
}
</style>